module.exports = __webpack_public_path__ + "img/menu8.5394a78a.png";